// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SaveIconSignature {
  Element: SVGSVGElement;
}

export const SaveIcon: TOC<SaveIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 21C20.103 21 21 20.103 21 19V9.414C21 8.888 20.787 8.372 20.414 8L16 3.586C15.622 3.208 15.12 3 14.586 3H5C3.897 3 3 3.896 3 5V19C3 20.103 3.897 21 5 21H19ZM5 19V5H14.586L19 9.414L19.001 19H5ZM12 18C10.346 18 9 16.654 9 15C9 13.346 10.346 12 12 12C13.654 12 15 13.346 15 15C15 16.654 13.654 18 12 18ZM11 15C11 14.449 11.449 14 12 14C12.551 14 13 14.449 13 15C13 15.551 12.551 16 12 16C11.449 16 11 15.551 11 15ZM13 7H15V10H13V7ZM11 7H7V10H11V7Z"/>
</svg>
</template>;